<!-- <img src="assets/images/background.png" class="Background"> -->
<div class="parent">
  <div class="deviceDetails">

    <div class="sidebar-top">
      <div class="cliqtest-logo"></div>
    </div>

    <div class="sidebar-middle">
      <button (click)="key('home')" title="Home" class="navbarbuttons" aria-label="Home">
        <!-- <img class="icons" src="assets/NavButtons/home.png" /> -->
        <!-- <i class="fa fa-home icons" aria-hidden="true"></i> -->
        <i class="fa-solid fa-house icons"></i>
      </button>

      @if (!device.ios) {
        <button (click)="key('app_switch')" title="Recent Apps" class="navbarbuttons">
          <!-- <img class="icons" src="assets/NavButtons/app.png" /> -->
          <i class="bi bi-distribute-horizontal icons" aria-hidden="true"></i>
        </button>
      }

      <button (click)="press('power')" title="Lock" class="navbarbuttons">
        <!-- <img class="icons" src="assets/NavButtons/Lock.png" /> -->
        <i class="fa fa-lock icons" aria-hidden="true"></i>
      </button>

      @if (!device.ios) {
        <button (click)="press('menu')" title="Unlock" class="navbarbuttons">
          <!-- <img class="icons" src="assets/NavButtons/Unlock.png" /> -->
          <i class="fa fa-unlock-alt icons" aria-hidden="true"></i>
        </button>
      }

      <button (click)="openSettings()" title="Settings" class="navbarbuttons">
        <!-- <img class="icons" src="assets/NavButtons/settings.png" /> -->

        <i class="fa fa-cog icons" aria-hidden="true"></i>
      </button>

      @if (!device.ios) {
        <button (click)="$event.stopPropagation(); toggleThrottleOptions()" title="Throttle Network"
          class="navbarbuttons">
          <!-- <img class="icons" src="assets/NavButtons/signal-status.png" /> -->
          <i class="fa fa-signal icons" aria-hidden="true"></i>
        </button>
      }

      @if (showThrottleOptions) {
        <div  class="throttle-dropdown-wrapper">
          <div class="throttle-arrow"></div>
          <div class="throttle-dropdown">
            @for (opt of throttleOptions; track opt) {
              <button (click)="applyThrottle(opt)"
                class="throttle-option-btn">
                {{ opt.label }}
              </button>
            }
          </div>
        </div>
      }

      <button (click)="aboutDeviceToggle()" title="About Device" class="navbarbuttons">
        <!-- <img class="icons" src="assets/NavButtons/info.png" /> -->
        <i class="fa fa-info-circle icons" aria-hidden="true"></i>
      </button>

      <button (click)="fullViewExitfunc()" title="Minimize the full-view" style="margin-top: 20px;" class="navbarbuttons">
        <i class="fa-solid fa-compress icons"></i>
      </button>
    </div>
  </div>
  <!-- [ngClass]="{'col-5 col-md-5':isNavbar,'col-6 col-md-6':!isNavbar}" -->
  <div class="mobileScreen col-5 col-md-5">
    <div class="positioner" [class.landscape]="isScreenRotated">
      @if (loader) {
        <div [ngStyle]="{'cursor':cursor,'aspect-ratio':canvasAspect}" class="mainDivLoader" [class.landscape]="isScreenRotated">
                <span [ngClass]="{'bi bi-android android': device?.platform == 'Android',
                                 'bi bi-apple iOS': device?.platform == 'iOS'}">
          </span>
          <label class="loadbar" [ngStyle]="{'top': getTopPosition(device)}">
            <span class="sr-only"></span>
            <progress class="progressBar"></progress>
          </label>
        </div>
      }
      <img [ngStyle]="{'aspect-ratio':canvasAspect}" [class.landscape]="isScreenRotated" class="wrapper" src="assets/Wrapper/Mobile_wrapper.png">
      <canvas #canvas class="screen" [class.landscape]="isScreenRotated" [class.portrait]="!isScreenRotated"></canvas>
      <input type="text" tabindex="40" accesskey="C" autocorrect="off" autocapitalize="off"
        focus-element="$root.screenFocus" />
    </div>
    <div class="device-name">{{device.model}}</div>
  </div>
  <div class="col-5 col-md-5 logSection">
    <ul class="nav nav-tabs" id="logTabs" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link active" id="appiumLogs-tab" data-bs-toggle="tab" data-bs-target="#appiumLogs"
        type="button" role="tab" aria-controls="appiumLogs" aria-selected="true">Appium Logs</button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="deviceSelection-tab" data-bs-toggle="tab" data-bs-target="#deviceSelection"
        type="button" role="tab" aria-controls="deviceSelection" aria-selected="false">Add Device</button>
      </li>
    </ul>

    <div class="tab-content" id="logsTabContent">
      <div class="tab-pane fade show active" id="appiumLogs" role="tabpanel" aria-labelledby="appiumLogs-tab">


        <div class="log-header">
          <button [ngClass]="appiumStatus ? 'btn-protean' : 'btn-protean'" (click)="getAppiumLogs()"
            class="protean-btn" type="button">
            {{ appiumStatus ? 'Stop Streaming' : 'Stream Appium Logs' }}
            <i [ngClass]="appiumStatus ? 'fa fa-stop' : 'fa fa-play'" style="margin-left: 8px;"></i>
          </button>
        </div>

        <div #logStream class="log-stream" (scroll)="onScroll()">
          <!-- <div *ngFor="let log of appiumLogs; let i = index" class="log-entry">
          <div [ngClass]="getLogClass(i)">{{ log }}</div>
        </div> -->
        @for (log of appiumLogs; track log; let i = $index) {
          <div class="log-entry">
            <div [ngClass]="getLogClass(i)" style="display: flex; flex-direction: row; align-items: start;">
                            <div class="fa-solid fa-circle" [style.color]="
                                getLogClass(i) === 'error-log' ? 'red' :
                                getLogClass(i) === 'warning-log' ? 'orange' :
                                'green'
                            " style="margin-right: 6px; margin-top: 2px" aria-hidden="true"></div>
              <div style="cursor: text;">
                {{ log }}
              </div>
            </div>
          </div>
        }
      </div>
    </div>


    <div class="tab-pane fade show" id="deviceSelection" role="tabpanel" aria-labelledby="deviceSelection-tab">

      <div class="toggle-container">
        <div>
          Select upto 3 Additional Devices
        </div>
        <!-- <input type="checkbox" id="toggle1" class="toggle-input" (click)="toggleDeviceSelection()"
        [checked]="selectMultiDevice"> -->
        <!-- <label for="toggle1" class="toggle-label" title="Toggle for multi device selection."></label> -->

        <!-- [ngStyle]="{'display': selectedDevices.length ? 'block' : 'none'}" -->
        <button class="btn launchButton protean-btn" [disabled]="!selectedDevices.length"
          (click)="launchMutliDevice()">
          Launch <i [ngClass]="'fa fa-play'" style="margin-left: 8px;"></i>
        </button>
      </div>
      <!-- The UL tag is placed here but will be accessible regardless of active tab -->
      <ul id="deviceList" class="devices-icon-view device-list"></ul>

    </div>
  </div>
</div>
</div>
@if (aboutDevice) {
  <div [ngStyle]="{'top':'21em','left':'11em'}"
    class="aboutDevice">
    <div class="w-full max-w-xs bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg p-6 text-white">
      <div class="flex justify-between items-center mb-4">
        <h3 [ngClass]="{'bi bi-android':device.platform=='Android','bi bi-apple':device.platform=='iOS'}"
        class="text-xl font-bold"> {{device.model}}</h3>
      </div>
      <div>
        <h6>{{device.platform=='iOS'?'Apple':device.manufacturer}}</h6>
      </div>
      <div class="space-y-3">
        <p class="text-sm opacity-80">S/N: {{device.serial}}</p>
        <div class="progress mb-2" style="height: 7px;">
          <div class="progress" style="background-color: rgb(4 161 4); height: 7px;align-items: center;"
            [ngStyle]="{'width':device.battery?.level+'%'}">
            <span style="position: relative;left: 43%;font-size: 8px;">{{device.battery?.level+'%'}}</span>
          </div>
        </div>
        <span class="ml-2 text-sm">Battery Status: {{device.battery?.status}}</span>
        <div class="flex items-center">
          <div class="w-full bg-white/30 rounded-full h-2.5">
            <div class="bg-green-500 h-2.5 rounded-full"></div>
          </div>
          <span class="ml-2 text-sm">Version: {{device.version}}</span>
        </div>
        <div class="flex items-center">
          <span class="bi bi-reception-4">{{device.network?.type}}</span>
        </div>
        <div class="flex items-center">
          <span></span>
        </div>
      </div>
    </div>
  </div>
}
@if (aboutDevice2) {
  <div [ngStyle]="{'top':isNavbar?'12.65em':'28.8em','left':isNavbar?'14em':'6em'}"
    class="aboutDevice">
    <div class="w-full max-w-xs bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg p-6 text-white">
      <div class="flex justify-between items-center mb-4">
        <h3 [ngClass]="{'bi bi-android':device2.platform=='Android','bi bi-apple':device2.platform=='iOS'}"
        class="text-xl font-bold"> {{device2.model}}</h3>
      </div>
      <div>
        <h6>{{device2.platform=='iOS'?'Apple':device2.manufacturer}}</h6>
      </div>
      <div class="space-y-3">
        <p class="text-sm opacity-80">S/N: {{device2.serial}}</p>
        <div class="progress mb-2" style="height: 7px;">
          <div class="progress" style="background-color: rgb(4 161 4); height: 7px;align-items: center;"
            [ngStyle]="{'width':device2.battery?.level+'%'}">
            <span style="position: relative;left: 43%;font-size: 8px;">{{device2.battery?.level+'%'}}</span>
          </div>
        </div>
        <span class="ml-2 text-sm">Battery Status: {{device2.battery?.status}}</span>
        <div class="flex items-center">
          <div class="w-full bg-white/30 rounded-full h-2.5">
            <div class="bg-green-500 h-2.5 rounded-full"></div>
          </div>
          <span class="ml-2 text-sm">Version: {{device2.version}}</span>
        </div>
        <div class="flex items-center">
          <span class="bi bi-reception-4">{{device2.network?.type}}</span>
        </div>
        <div class="flex items-center">
          <span></span>
        </div>
      </div>
    </div>
  </div>
}
@if (screenRecord) {
  <div _ngcontent-ng-c1826359624="">
    <app-draggable-component (screenRecordFunc)="screenRecord"></app-draggable-component>
  </div>
}
<ng-template #screenshotAlert let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{msg | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="Ok()">OK</button>
    </div>
  </div>
</ng-template>
<ng-template #AppUpload let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{"Upload the apk file" | translate}}</p>

    <!-- Added accept attribute and basic styling -->
    <label id="file-upload" class="drop-area file-input btn-file ng-isolate-scope">
      <input #appInstall type="file" id="file-upload" accept=".apk" (input)="onFileSelected($event)"
        class="ng-isolate-scope" style="display: none;">
      <i class="fa fa-2x fa-upload drop-area-icon" style="cursor: pointer;"></i>
      <div class="drop-area-text"><span style="cursor: pointer;">{{"Drop file to upload" | translate}}</span>
    </div>
  </label>

  @if (appInstalling) {
    <div class="progress">
      <div class="progress-bar" role="progressbar" [style.width.%]="progress" [attr.aria-valuenow]="progress"
        aria-valuemin="0" aria-valuemax="100">
        {{ "Uploading " + progress }}%
      </div>
    </div>
  }
  <button class="btn btn-primary mt-3" (click)="Ok()">Ok</button>
</div>
</ng-template>